import {lazyLoadView} from "@utils/views";

export default {
    path: '/citizen',
    name: 'citizen',
    component: () => lazyLoadView(import('@views/citizen.vue')),
    meta: {
        authRequired: false,
        beforeResolve(routeTo, routeFrom, next) {
            return next();
        },
    }
}
